import { useRootStore } from '~/store/root'
import routeAuth from '~/libs/route-authentication'

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (useRootStore().isLoggedIn) clearWidgetRedirectMarker()

  if (!routeAuth.isPublicRoute(to, to.query) && !useRootStore().isLoggedIn) {
    const redirectPath = !to.fullPath.includes('identity') ? to.fullPath : undefined

    const { $lendioCookies } = useNuxtApp()
    // This bypasses the /identity/login?r=... route, so set the 'redirect'
    // cookie here too -- /identity/sso's tokenLogin() reads it after SSO.
    if (redirectPath) {
      $lendioCookies.set('redirect', parseInternalRedirect(redirectPath), { maxAge: 60 * 10 })
    }
    return redirectToWidget(redirectPath)
  }
})
